import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import '../../style/tobaList.css'
import ModalWrapper from '../../helpers/modalWrapper';
import GroupButtons from '../../helpers/groupButtons';
import TobaFormHOC from '../../containers/Tobas/tobaFormHOC';
import {LEGAL_ADVICE_TEXT, TOBA_PATH, TOBA_SHORT_TEXT, UI_LIB_TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import {Alert, Button, FormInline, Heading, Loader, Table, Link} from 'arag-ui-lib';
import {DOTS, ERROR, HEADING_2, MEDIUM, MOMENT_DATE_TIME_FORMAT_12_HOUR, PRIMARY, RIGHT, SIZE_LG, SIZE_MD, TERTIARY} from "../../helpers/constants";
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import {goAtEnd, goAtNext, goAtPage, goAtPrevious, goAtStart} from '../../helpers/functions';

const columns = [
    {propertyName: "name", header: CONTENT_STRINGS.NAME},
    {propertyName: "version", header: CONTENT_STRINGS.VERSION}
];

const formatSolicitorGroup = (d) => `${d.name} ${moment(d.startDate).format(MOMENT_DATE_TIME_FORMAT_12_HOUR)} - ${d.expiryDate !== null ? moment(d.expiryDate).format(MOMENT_DATE_TIME_FORMAT_12_HOUR) : ''}`;

const getAccordionItemHeader = (row) => `${CONTENT_STRINGS.NAME}: ${row.name} ${CONTENT_STRINGS.VERSION}: ${row.version}`;

const TobaList = (props) => {
    const {
        tobaList,
        onListItemSelect,
        onSelectAllItems,
        tobas,
        fetchingTobas,
        _handleStoreChange,
        _closeModal,
        _deleteSelectedTobas,
        _viewTobaSolicitorGroupsInModal,
        _closeTobaSolicitorGroupsModal,
        _closeTobaFormModal,
        _openTobaFormModal,
        _handleApplyButton,
        _handleSelectChange,
        _pushRoute,
    } = props;

    const currentPage = parseInt(tobaList.page);
    const totalPages = tobaList.totalPaginationBoxes;

    const handlePageChange = (page) => _handleStoreChange('page', page);
    const handlePageSizeChange = (evt) => _handleStoreChange('displayAmount', evt.target.value);
    const handleViewGroupsClick = (tobaId) => () => _viewTobaSolicitorGroupsInModal(tobaId);
    const handleViewDetailsRowClick = (row) => _pushRoute(`/solicitors/${TOBA_PATH}s/` + row.id);
    const handleViewGroupsRowClick = (row) => _viewTobaSolicitorGroupsInModal(row.id);

    const renderSelectedTobaRow = (t, index) => (
        <div key={index} style={{display: 'flex', justifyContent: 'flex-start'}}>
            <FormInline
                label={t.name}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: `toba-delete-modal-${index}`,
                    name: `toba-delete-modal-${index}`,
                }}
                //viewControlTestId={''}
            />
            <Link
                label={`${CONTENT_STRINGS.VIEW_SOLICITOR_GROUPS_LINK_TEXT} ${TOBA_SHORT_TEXT}`}
                onClick={handleViewGroupsClick(t.id)}
                variant={TERTIARY}
                // linkTestId={``}
            />
        </div>
    );

    const selectedToba = _.find(tobas, t => t.id === tobaList.selectedTobaToSeeGroups);
    const selectedTobaGroupsSummary = selectedToba && selectedToba.solicitorGroupDtos
        ? selectedToba.solicitorGroupDtos.map(formatSolicitorGroup).join(', ')
        : '';

    const tableSelectActions = [
        {key: 'delete', label: CONTENT_STRINGS.DELETE},
    ];

    const tableActions = [
        {
            key: 'details',
            label: `${CONTENT_STRINGS.VIEW} ${CONTENT_STRINGS.DETAILS}`,
            callback: handleViewDetailsRowClick,
        },
        {
            key: 'viewGroups',
            label: `${CONTENT_STRINGS.VIEW} ${CONTENT_STRINGS.GROUPS}`,
            callback: handleViewGroupsRowClick,
        },
    ];

    return (
        <div>
            <ModalWrapper
                isOpen={tobaList.deleteModalOpen}
                onClose={_closeModal}
                size={SIZE_MD}
                title={CONTENT_STRINGS.ARE_YOU_SURE}
                modalTestId={'delete-toba-modal'}
                footer={
                    <GroupButtons
                        primaryLabel={CONTENT_STRINGS.YES}
                        onPrimaryClick={_deleteSelectedTobas}
                        primaryTestId={'delete-tobal-modal-yes'}
                        secondaryLabel={CONTENT_STRINGS.NO}
                        onSecondaryClick={_closeModal}
                        secondaryTestId={'delete-tobal-modal-no'}
                    />
                }
            >
                <FormInline
                    variant={FORM_GROUP_VARIANTS.PLAIN}
                    label={<>{CONTENT_STRINGS.DELETE_TOBA_CONFIRMATION_PREFIX} <strong>{CONTENT_STRINGS.DELETE}</strong> {CONTENT_STRINGS.DELETE_TOBA_CONFIRMATION_SUFFIX} {TOBA_SHORT_TEXT}s</>}
                    inputProps={{
                        id: 'delete-toba-confirmation',
                        name: 'delete-toba-confirmation',
                    }}
                    viewControlTestId={'delete-tobal-modal-message'}
                />
                {_.map(tobaList.selectedTobas, renderSelectedTobaRow)}
                {
                    tobaList.deleting
                    ?
                        <Loader variant={DOTS} dotSize={MEDIUM}/>
                    :
                        null
                }
                {
                    tobaList.badResponseMsg
                    ?
                        <Alert label={tobaList.badResponseMsg} variant={ERROR} />
                    :
                        null
                }
            </ModalWrapper>
            <ModalWrapper
                isOpen={tobaList.openTobaGroupDetailsModal}
                onClose={_closeTobaSolicitorGroupsModal}
                size={SIZE_MD}
                modalTestId={'toba-view-groups-modal'}
            >
                <FormInline
                    variant={FORM_GROUP_VARIANTS.PLAIN}
                    label={`${CONTENT_STRINGS.NAME}: `}
                    inputProps={{
                        label: selectedToba ? selectedToba.name : ''
                    }}
                    viewControlTestId={'toba-view-groups-modal-name'}
                />
                <FormInline
                    variant={FORM_GROUP_VARIANTS.PLAIN}
                    label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUPS}`}
                    inputProps={{
                        label: selectedTobaGroupsSummary
                    }}
                    viewControlTestId={'toba-view-groups-modal-groups'}
                />
            </ModalWrapper>
            <ModalWrapper
                isOpen={tobaList.tobaFormModalOpen}
                onClose={_closeTobaFormModal}
                size={SIZE_LG}
                modalTestId={'tobas-create-toba-modal'}
            >
                <TobaFormHOC handleCancel={_closeTobaFormModal} />
            </ModalWrapper>
            <Heading variant={HEADING_2} title={`${TOBA_SHORT_TEXT}s`} />
            <div className="row form-group">
                <div className="col-sm-9">
                    <Button
                        onClick={_openTobaFormModal}
                        variant={PRIMARY}
                        arrowDirection={RIGHT}
                        label= {`${CONTENT_STRINGS.CREATE_NEW} ${TOBA_SHORT_TEXT}`}
                        buttonTestId={'tobas-create-new'}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <Table
                        onSelectedActionApply={_handleApplyButton}
                        onSelectAction={_handleSelectChange}
                        selectedAction={tobaList.selectedAction}
                        selectActions={tableSelectActions}
                        onSelectAll={onSelectAllItems}
                        onDatumSelect={onListItemSelect}
                        selected={tobaList.selectedTobas}
                        selectable
                        accordionItemHeaderFormatter={getAccordionItemHeader}
                        onPageSizeChange={handlePageSizeChange}
                        goAtPrevious={goAtPrevious(handlePageChange, currentPage)}
                        goAtNext={goAtNext(handlePageChange, currentPage, totalPages)}
                        goAtStart={goAtStart(handlePageChange)}
                        goAtEnd={goAtEnd(handlePageChange, totalPages)}
                        goAtPage={goAtPage(handlePageChange)}
                        loading={fetchingTobas}
                        responsive
                        striped
                        columns={columns}
                        data={tobas}
                        pageSize={parseInt(tobaList.displayAmount)}
                        totalRecords={tobaList.totalRecords}
                        totalPages={totalPages}
                        page={currentPage}
                        hasActions
                        actions={tableActions}
                        pageSizeOptions={UI_LIB_TABLE_VIEW_OPTIONS}
                        tableWrapperTestId={'tobas-table'}
                    />
                </div>
            </div>
        </div>
    )
};

export default TobaList;
